import { useEffect, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

const scrollToTop = () => {
  window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
  if (document.scrollingElement) {
    document.scrollingElement.scrollTop = 0;
  }
};

const ScrollToTop = () => {
  const { pathname, search, hash, key } = useLocation();

  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  useLayoutEffect(() => {
    if (hash) {
      return;
    }
    scrollToTop();
  }, [pathname, search, key, hash]);

  useEffect(() => {
    if (hash) {
      const id = decodeURIComponent(hash.replace("#", ""));
      const timers = [50, 150, 400].map((delay) =>
        setTimeout(() => {
          const el = document.getElementById(id);
          if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }, delay)
      );
      return () => timers.forEach(clearTimeout);
    }

    scrollToTop();
    const timers = [0, 50, 150, 300, 600].map((delay) =>
      setTimeout(scrollToTop, delay)
    );
    const frame = requestAnimationFrame(scrollToTop);

    return () => {
      timers.forEach(clearTimeout);
      cancelAnimationFrame(frame);
    };
  }, [pathname, search, key, hash]);

  return null;
};

export default ScrollToTop;
